var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",style:({height: _vm.windowHeight + 'px'}),attrs:{"data-flex":"dir:top main:center cross:center"}},[_c('p',{attrs:{"data-flex-box":"0"}},[_vm._v("我的订单页面")])])}
var staticRenderFns = []

export { render, staticRenderFns }